var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":"","outline":"","type":"button"},on:{"click":function($event){return _vm.generate()}}},[_vm._v("Προτεινε μου κωδικο")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }